const getters = {
  getPartners: (state) => state.partners,
  getPartner: (state) => state.partner,
};

export default getters;
